import { FormattedMessage } from 'react-intl';

import { FullWidthContainer } from 'atoms/layout/FullWidthContainer';
import { Vertical } from 'atoms/layout/flex';
import { HeadlineS } from 'atoms/typography';
import { glossary } from 'lib/glossary';

import type { Props as RelatedClubProps } from './RelatedClub';
import { RelatedClub } from './RelatedClub';

type Props = {
  clubs: RelatedClubProps['club'][];
};

export const RelatedClubs = ({ clubs }: Props) => {
  return (
    <FullWidthContainer>
      <Vertical gap={1.5}>
        <HeadlineS as="h2">
          <FormattedMessage {...glossary.relatedClubs} />
        </HeadlineS>
        {clubs.map(club => (
          <RelatedClub key={club.slug} club={club} />
        ))}
      </Vertical>
    </FullWidthContainer>
  );
};
